import classNames from 'classnames';
import React, {useMemo} from 'react';

import * as DataTableConstants from 'notebook/data-tables/DataTableConstants';
import Label from 'ui-library/bs/Label';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

interface DeletableFieldFilterRowProps {
  allFields: Array<{id: number; name: string}>;
  tagSchemaField: {id: number; name: string};
  value: string | null;
  onEdit: (field: {id: number; name: string}, value: string | null) => void;
  onDelete: () => void;
}

function DeletableFieldFilterRow(props: DeletableFieldFilterRowProps): JSX.Element {
  // this.props.onEdit(_.findWhere(this.props.allFields, {id: e.val})!, this.props.value);
  const fieldsById = useMemo(
    () =>
      props.allFields.reduce<
        Record<
          number,
          {
            id: number;
            name: string;
          }
        >
      >((acc, field) => {
        acc[`${field.id}`] = field;
        return acc;
      }, {}),
    [props.allFields]
  );
  const optionDatas = useMemo(
    () =>
      props.allFields.map((field) => ({
        value: `${field.id}`,
        name: field.name,
      })),
    [props.allFields]
  );
  return (
    <div className="workflowConfigureScreen-deletable-row u-flex-display u-tiny-spacing-bottom">
      <div
        className={classNames(
          'u-flex-grow',
          props.tagSchemaField ? '' : 'lookupFieldFiltersSelector-placeholder'
        )}
      >
        <SelectDropdown
          displayName={props.tagSchemaField?.name ?? 'Field name'}
          menu={
            <SearchableMenu
              onSelect={(selectedValue) => {
                props.onEdit(fieldsById[selectedValue], props.value);
              }}
              optionDatas={optionDatas}
              selectedValue={props.tagSchemaField?.id ?? null}
              width={MenuWidth.FULL}
            />
          }
        />
      </div>
      <div className="u-flex-grow u-small-spacing-left">
        <input
          className="fieldInput-input"
          value={props.value || ''}
          onChange={(e) => {
            props.onEdit(props.tagSchemaField, e.target.value);
          }}
          placeholder="Value"
          type="text"
        />
      </div>
      <div
        className="u-flex-none u-vertical-center-items u-justify-content-center u-tiny-spacing-left"
        style={{width: 30}}
      >
        <BenchlingIcon
          className="workflowConfigureScreen-delete faded u-danger-pointer"
          icon="delete"
          onClick={props.onDelete}
        />
      </div>
    </div>
  );
}

interface FiltersSelectorProps {
  dataTableConfig: DataTableConstants.FromServerDataTableConfig;
  filterSpecifiers: Array<{
    fieldFilter: {
      name: string | null;
      value: string | null;
    };
  }>;
  onAddFilter: () => void;
  onDeleteFilter: (filterIndex: number) => void;
  onEditFilter: (filterIndex: number, field: {id: number; name: string}, value: string | null) => void;
}

const FiltersSelector: React.FC<FiltersSelectorProps> = ({
  onAddFilter,
  filterSpecifiers,
  dataTableConfig,
  onEditFilter,
  onDeleteFilter,
}: FiltersSelectorProps): JSX.Element => (
  <div>
    <div>
      <Label>FILTERS</Label>
      <BenchlingIcon
        className="workflowConfigureScreen-compose u-pointer"
        icon="compose"
        onClick={onAddFilter}
      />
    </div>
    {filterSpecifiers.length === 0 ? (
      <div className="u-faded">Filter on specific field values</div>
    ) : (
      filterSpecifiers.map((filter, filterIndex) => (
        <DeletableFieldFilterRow
          key={filterIndex}
          allFields={dataTableConfig.columns}
          tagSchemaField={dataTableConfig.columns.find((column) => column.name === filter.fieldFilter.name)!}
          value={filter.fieldFilter.value}
          onEdit={(field, value) => {
            onEditFilter(filterIndex, field, value);
          }}
          onDelete={() => {
            onDeleteFilter(filterIndex);
          }}
        />
      ))
    )}
  </div>
);

export default FiltersSelector;
